import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'suffixLabel'
})
export class SuffixLabelPipe implements PipeTransform {

    constructor(private translationService: TranslateService) {
    }

    transform(value: any, suffixLabel: string): string {
        if (value === null) {
            return null;
        }
        const suffix = this.translationService.instant(suffixLabel);
        return `${value} ${suffix}`;
    }
}
